import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import LoadingSpinner from 'components/LoadingSpinner'
import { selectContext } from 'selectors/auth'
import { isScratchAdminUser } from 'util/user'

/**
 * Guard that restricts access to Scratch Admin users only.
 * Non-admin users are redirected to /dashboard.
 */
const ScratchAdminGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const context = useSelector(selectContext)

	if (!context.user) {
		return <LoadingSpinner />
	}

	if (!isScratchAdminUser(context.user)) {
		return <Navigate to="/dashboard" />
	}

	return <>{children}</>
}

export default ScratchAdminGuard
